module.exports = __webpack_public_path__ + "static/media/lasa.e3545242.mp3";